<template>
  <div class="border border-gray-400 rounded-lg overflow-hidden">
    <div class="h-2 border-b border-gray-400 bg-white" />

    <div class="flex-1 bg-white">
      <div class="list list--nested">
        <!--
          List Header
        -->
        <div class="list__header flex px-6 space-x-6">
          <div class="flex-1 py-3">
            {{ packageEdition.name }}
          </div>
        </div>

        <!--
          List Body
        -->
        <div class="list__body">
          <!--
            List Item
          -->
          <div
            v-for="packageItem in packageItems"
            :key="packageItem.id"
            class="list__item flex leading-normal px-6 space-x-6"
          >
            <div class="flex-1 py-5">
              {{ packageItem.name }}
            </div>
            <div v-if="packageItem.optional" class="flex-none py-5">
              <label class="custom-checkbox">
                <input
                  type="checkbox"
                  :checked="packageItemIds.indexOf(packageItem.id) !== -1"
                  :disabled="processing"
                  @input="doCheck(packageItem.id, $event.target.checked)"
                />
                <span />
              </label>
            </div>
          </div>
          <div v-if="!confirmDelete" class="list__item flex leading-normal p-6 justify-between">
            <button
              type="button"
              :disabled="processing"
              class="btn style-link capitalize -ml-4"
              @click="doConfirm"
            >
              {{ $te('delete') ? $t('delete') : 'delete' }}
            </button>
            <button
              type="button"
              :disabled="processing"
              class="btn btn-brand capitalize"
              @click="doSubmit"
            >
              {{ $te('update') ? $t('update') : 'update' }}
            </button>
          </div>
          <div v-else class="list__item flex flex-col leading-normal p-6">
            <div class="capitalize text-center">
              {{ $te('deleteConfirmation') ? $t('deleteConfirmation') : 'please confirm' }}
            </div>
            <div class="flex flex-col space-y-4 border-t pt-4 mt-6">
              <button
                type="button"
                :disabled="processing"
                class="btn style-link capitalize"
                @click="confirmDelete = false"
              >
                {{ $te('cancel') ? $t('cancel') : 'cancel' }}
              </button>
              <button
                type="button"
                :disabled="processing"
                class="btn btn-danger capitalize"
                @click="doDelete"
              >
                {{ $te('delete') ? $t('delete') : 'delete' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PackageEditionSingle',
  props: {
    packageEdition: {
      type: Object,
      required: true,
    },
    packageItems: {
      type: Array,
      required: true,
    },
    processing: Boolean,
  },
  data() {
    return {
      packageItemIds: [...(this.packageEdition.packageItems || [])],
      confirmDelete: false,
    };
  },
  watch: {
    'packageEdition.packageItems': {
      handler(packageItemIds) {
        this.packageItemIds = [...packageItemIds];
      },
      deep: true,
    },
  },
  methods: {
    doCheck(packageItemId, checked) {
      if (checked && this.packageItemIds.indexOf(packageItemId) === -1) {
        this.packageItemIds.push(packageItemId);
      }
      if (!checked && this.packageItemIds.indexOf(packageItemId) !== -1) {
        this.packageItemIds = [...this.packageItemIds.filter((id) => id !== packageItemId)];
      }
    },
    doSubmit() {
      const { packageEdition, packageItemIds } = this;
      this.$emit('submit', {
        packageEditionId: packageEdition.id,
        updateData: { packageItemIds },
      });
    },
    doConfirm() {
      this.confirmDelete = true;
    },
    doDelete() {
      this.$emit('delete', this.packageEdition.id);
    },
  },
};
</script>
